import React from "react";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import MenuCart from "./MenuCart";

const RelatedProduct = ({ productData, setShowModal, setUrl }) => {
  return (
    <div className="related_menu mt_90 xs_mt_60">
      <h2>related items</h2>

      <Swiper
        breakpoints={{
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 5,
          },
        }}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        zoom={true}
        navigation={true}
        pagination={{
          clickable: true,
        }}
        modules={[Navigation]}
        className="relatedSwiper pt-5"
      >
        {productData.map((e, i) => (
          <SwiperSlide>
            <MenuCart
              setUrl={setUrl}
              setShowModal={setShowModal}
              width={true}
              productData={e}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
export default RelatedProduct;
